module.exports = __webpack_public_path__ + "img/Slide17.149a7c1e.png";